// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    :host {
      height: 24px;
      min-width: 24px;
      display: inline-block;
      color: green;
      line-height: 0;
      margin-right: 5px;
    }
  `, "",{"version":3,"sources":["webpack://./src/app/core/svg-icons/check-circle-icon.component.ts"],"names":[],"mappings":";IACI;MACE,YAAY;MACZ,eAAe;MACf,qBAAqB;MACrB,YAAY;MACZ,cAAc;MACd,iBAAiB;IACnB","sourcesContent":["\n    :host {\n      height: 24px;\n      min-width: 24px;\n      display: inline-block;\n      color: green;\n      line-height: 0;\n      margin-right: 5px;\n    }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
